import { ClassName, GADataType, I18nText } from '../../../../../types';
import { IconsEnum } from '../../../../../assets/icons/types';
import { SelectedProductUUID } from '../../../selectedProductsTypes';

import {
  FETCH_SELECTED_PRODUCT_DOWNLOAD_URLS_QUERY,
  FetchSelectedProductDownloadUrlsQueryResponse
} from '../../../queries/fetchSelectedProductDownloadUrls.query';

import { useSelectedProduct } from '../../../../selectedProducts/hooks/useSelectedProduct';
import { useShowToastOnErrorChange } from '../../../../../common/hooks/useShowToastOnErrorChange';

import { DownloadUrlsModalButton } from '../../../../common/components/modalButtons/DownloadUrlsModalButton';

import { SelectedProductCache } from '../../../SelectedProductCache';

import { TooltipPlacement } from '../../../../../helpers/tooltips/tooltipsConstants';

interface DownloadSelectedProductSeparatelyButtonProps {
  className?: ClassName;
  i18nText?: I18nText;
  icon?: IconsEnum;
  iconClassName?: ClassName;
  selectedProductUuid: SelectedProductUUID;
  tooltipI18nText?: I18nText;
  tooltipPlacement?: TooltipPlacement;
  tooltipSingleton?: boolean;
}

function DownloadSelectedProductSeparatelyButton({
  className,
  dataGa,
  i18nText,
  icon,
  iconClassName,
  selectedProductUuid,
  tooltipI18nText,
  tooltipPlacement,
  tooltipSingleton
}: DownloadSelectedProductSeparatelyButtonProps & GADataType) {
  const {
    selectedProductLoading,
    refetchSelectedProduct,
    selectedProductError
  } = useSelectedProduct<FetchSelectedProductDownloadUrlsQueryResponse>({
    cacheKey: SelectedProductCache.downloadUrls(selectedProductUuid),
    options: {
      enabled: false,
      enabledPlaceholder: false
    },
    query: FETCH_SELECTED_PRODUCT_DOWNLOAD_URLS_QUERY,
    uuid: selectedProductUuid
  });

  useShowToastOnErrorChange({ error: selectedProductError });

  return (
    <DownloadUrlsModalButton<'selectedProduct'>
      className={className}
      dataGa={dataGa}
      disabled={selectedProductLoading}
      downloadUrlsScope="downloadUrls"
      i18nText={i18nText}
      icon={icon}
      iconClassName={iconClassName}
      refetchItemDownloadUrls={refetchSelectedProduct}
      scope="selectedProduct"
      tooltipI18nText={tooltipI18nText}
      tooltipPlacement={tooltipPlacement}
      tooltipSingleton={tooltipSingleton}
    />
  );
}

export default DownloadSelectedProductSeparatelyButton;
